import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-delicious-circle",
  "use": "icon-si-glyph-delicious-circle-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-delicious-circle\" id=\"icon-si-glyph-delicious-circle\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>945</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M16.916,9.021 C16.916,4.652 13.361,1.111 8.979,1.111 C4.594,1.111 1.041,4.652 1.041,9.021 C1.041,13.389 4.595,16.93 8.979,16.93 C13.361,16.931 16.916,13.39 16.916,9.021 L16.916,9.021 Z M8.903,9.084 L2.976,9.084 C2.976,5.745 5.71,3.04 9.083,3.04 C9.092,3.04 9.1,3.041 9.108,3.041 L9.108,8.906 L15.189,8.906 C15.189,12.235 12.263,15.11 8.902,15.125 L8.902,9.084 L8.903,9.084 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-delicious-circle.svg
// module id = 70lE
// module chunks = 62